import type {
  ComplianceTrackingDataInput,
  EverflowTrackingInput,
} from "@portal/app/_server/generated/resolvers";
import type { SubmitFormFunnelLeadMutationVariables } from "@portal/app/_components/formFunnel/hooks/generated";
import { mapEverflowAffiliateParams, type EverflowAffiliateParams } from "./everflowParameters";

// The existing compliance input omits offer URL IDs. The provider exposes uid
// separately as everflowUid; keep that protocol boundary explicit.
type FormFunnelEverflowField = Exclude<keyof EverflowAffiliateParams, "everflowOfferUrlId">;
export type FormFunnelEverflowAffiliateParams<Value> = Record<FormFunnelEverflowField, Value>;

function assertGraphqlFieldCoverage<Missing extends never>(..._missing: Missing[]): void {}
assertGraphqlFieldCoverage<Exclude<FormFunnelEverflowField, keyof ComplianceTrackingDataInput>>();
assertGraphqlFieldCoverage<
  Exclude<
    FormFunnelEverflowField,
    keyof SubmitFormFunnelLeadMutationVariables["complianceTracking"]
  >
>();
assertGraphqlFieldCoverage<Exclude<keyof EverflowAffiliateParams, keyof EverflowTrackingInput>>();

/** Preserve each caller's null/undefined values while projecting registered compliance fields. */
export function mapFormFunnelEverflowParams<Value>(
  getValue: (field: FormFunnelEverflowField) => Value
): FormFunnelEverflowAffiliateParams<Value> {
  const { everflowOfferUrlId: _offerUrlId, ...params } = mapEverflowAffiliateParams((field) =>
    field === "everflowOfferUrlId" ? undefined : getValue(field)
  );
  return params as FormFunnelEverflowAffiliateParams<Value>;
}
